import React, {useMemo} from 'react'
import styled from 'styled-components'
import {useTranslation} from 'i18n'
import {getBorder} from 'utils'
import {Paragraph} from 'common/components'
import convertUnit from 'lib/unit'

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${convertUnit(4)};
  text-align: left;
  padding: ${convertUnit(12)} ${convertUnit(20)};
  border-radius: ${convertUnit(8)};
  border: ${({theme}) => getBorder(convertUnit(1), 'solid', theme.gray_1)};
  background-color: ${({theme}) => theme.white_3};
  box-sizing: border-box;
`

export default function PaymentCheckoutStatusSuccessPackageInfo() {
  const {translate} = useTranslation()

  const handleRenderTitle = useMemo(
    () => (
      <Paragraph fontSize="m" fontWeight="bold" color="primary_5">
        {translate('payment:checkoutPackageInfoTitle')}
      </Paragraph>
    ),
    [translate],
  )

  const handleRenderDescription = useMemo(
    () => (
      <Paragraph fontSize="s" color="gray_6">
        {translate('payment:checkoutPackageInfoDescription')}
      </Paragraph>
    ),
    [translate],
  )

  return (
    <StyledContainer>
      {handleRenderTitle}
      {handleRenderDescription}
    </StyledContainer>
  )
}
